<template>
  <nav class="bg-blue-900 bg-opacity-80 backdrop-blur-sm p-4 sticky top-0 z-50 shadow-lg" style="font-family: 'Oswald', sans-serif; font-size: 18px;">
    <div class="container mx-auto flex justify-between items-center">
      <!-- Logo -->
      <router-link to="/" class="flex items-center text-white hover:text-white">
        <img src="../assets/images/logo.jpeg" alt="Trevia Systems Logo" class="h-12 mr-3" />
        <span class="font-semibold text-xl">Trevia Systems & Services</span>
      </router-link>

      <!-- Desktop Navigation -->
      <div class="hidden md:flex space-x-6">
        <router-link to="/" class="text-white hover:text-yellow-500 transition-colors duration-300">Home</router-link>
        <router-link to="/about" class="text-white hover:text-yellow-500 transition-colors duration-300">About Us</router-link>
        <router-link to="/services" class="text-white hover:text-yellow-500 transition-colors duration-300">Services</router-link>
        <!-- Uncomment if needed -->
        <!-- <router-link to="/clients" class="text-white hover:text-yellow-500 transition-colors duration-300">Clients</router-link> -->
        <router-link to="/contact" class="text-white hover:text-yellow-500 transition-colors duration-300">Contact</router-link>
      </div>

      <!-- Mobile Menu Button -->
      <button
          @click="toggleMobileMenu"
          class="md:hidden text-white focus:outline-none transition-colors duration-300"
          :class="{ 'hamburger-open': mobileMenuOpen }"
          aria-label="Toggle mobile menu"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
              v-if="!mobileMenuOpen"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16m-7 6h7"
          />
          <path
              v-else
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <!-- Mobile Menu -->
      <div
          v-if="mobileMenuOpen"
          class="md:hidden absolute top-full right-4 bg-blue-900 bg-opacity-80 backdrop-blur-sm p-4 rounded-lg shadow-lg z-50 border border-blue-800 border-opacity-50 mt-2"
      >
        <router-link
            to="/"
            class="block py-2 text-white hover:text-yellow-500 transition-colors duration-300"
            @click="closeMobileMenu"
        >
          Home
        </router-link>
        <router-link
            to="/about"
            class="block py-2 text-white hover:text-yellow-500 transition-colors duration-300"
            @click="closeMobileMenu"
        >
          About Us
        </router-link>
        <router-link
            to="/services"
            class="block py-2 text-white hover:text-yellow-500 transition-colors duration-300"
            @click="closeMobileMenu"
        >
          Services
        </router-link>
        <!-- Uncomment if needed -->
        <!-- <router-link
          to="/clients"
          class="block py-2 text-white hover:text-yellow-500 transition-colors duration-300"
          @click="closeMobileMenu"
        >
          Clients
        </router-link> -->
        <router-link
            to="/contact"
            class="block py-2 text-white hover:text-yellow-500 transition-colors duration-300"
            @click="closeMobileMenu"
        >
          Contact
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue';

const mobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
};

const closeMobileMenu = () => {
  mobileMenuOpen.value = false;
};
</script>

<style scoped>
/* Ensure hamburger icon changes color when open */
.hamburger-open svg {
  color: #facc15; /* Yellow for active state */
}

/* Ensure router-link-active doesn't override white text */
.router-link-active,
.router-link-exact-active {
  color: #facc15 !important; /* Yellow for active links */
  font-weight: 600;
}

/* Smooth hover transitions */
.transition-all {
  transition-property: all;
}
.duration-300 {
  transition-duration: 300ms;
}
</style>